import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

/**
 * A card component displaying detailed energy usage statistics across multiple time periods
 * 
 * @param {Object} props - Component props
 * @param {Object} props.usage - Usage data object with today, thisWeek, and thisMonth properties
 * @param {boolean} props.showViewDataLink - Whether to show the "View Electricity Data" link
 */
const UsageStatsCard = ({ usage, showViewDataLink = true }) => {
  return (
    <div className="card bg-white shadow-md rounded-lg p-6">
      <h2 className="text-gray-500 text-sm font-semibold uppercase mb-2 font-mont">Electricity Usage</h2>
      <div className="space-y-2">
        <div className="flex justify-between">
          <span className="text-gray-600">Today:</span>
          <span className="font-semibold">
            {(typeof usage.today === 'number' ? usage.today.toFixed(1) : '0.0')} kWh
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">This Week:</span>
          <span className="font-semibold">
            {(typeof usage.thisWeek === 'number' ? usage.thisWeek.toFixed(1) : '0.0')} kWh
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">This Month:</span>
          <span className="font-semibold">
            {(typeof usage.thisMonth === 'number' ? usage.thisMonth.toFixed(1) : '0.0')} kWh
          </span>
        </div>
      </div>
      {showViewDataLink && (
        <Link 
          to="/electricity-data" 
          className="mt-4 text-sm text-blue-500 hover:text-blue-700 inline-flex items-center"
        >
          View Electricity Data →
        </Link>
      )}
    </div>
  );
};

UsageStatsCard.propTypes = {
  usage: PropTypes.shape({
    today: PropTypes.number,
    thisWeek: PropTypes.number,
    thisMonth: PropTypes.number
  }),
  showViewDataLink: PropTypes.bool
};

export default UsageStatsCard; 